import service from '@/utils/server';
const modName = '/home/main/';

//查询公告
export const getNotice = data => {
  return service({
    url: modName + 'homeInitPage',
    method: 'post'
  });
}



// WEBPACK FOOTER //
// ./src/page/home/api/index.js